import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import React from 'react';
import If from '#/common/components/If';
import AlertDataGrid from '../AlertDataGrid';
import AlertList from '../AlertList';

const Alerts: React.FC = () => {
  const { isDesktop } = useViewport();
  return (
    <>
      <If condition={isDesktop}>
        <AlertDataGrid />
      </If>
      <If condition={!isDesktop}>
        <AlertList />
      </If>
    </>
  );
};

export default React.memo(Alerts);
